import { SelectionRequiredError, UnknownServiceError } from '../../errors'

// Which of the project's services a command is about.
//
// A deploy touches only the services it names, so "everything" has to be asked for. The one exception is a
// project with a single service, where there is nothing to disambiguate.
//
// Generic over anything with a `serviceId` so the same rules cover a discovered service, a planned one, and
// a service listed by the workspace — the question is the same in all three cases.

export interface Selection {
  /** Explicit ids. Wins over `all`. */
  serviceIds?: string[]
  /** Take every candidate. */
  all?: boolean
}

export function selectServices<T extends { serviceId: string }>(
  available: T[],
  selection: Selection = {}
): T[] {
  const ids = available.map(entry => entry.serviceId)

  if (selection.serviceIds?.length) {
    return selection.serviceIds.map(serviceId => {
      const match = available.find(entry => entry.serviceId === serviceId)

      if (!match) {
        throw new UnknownServiceError(serviceId, ids)
      }

      return match
    })
  }

  if (selection.all || available.length === 1) {
    return available
  }

  throw new SelectionRequiredError(ids)
}
